import styled from 'styled-components';

export const StyledProgressFeedback = styled.div`
  .clickable {
    cursor: pointer;
  }
  .progress-slot-tooltip {
    position: relative;
    .out-of-date {
      position: absolute;
      top: calc(50% - ${({ size }) => (size == 'small' ? '5px' : '9px')});
      left: calc(50% - ${({ size }) => (size == 'small' ? '5px' : '9px')});
      font-size: ${({ size }) => (size == 'small' ? '10px' : '18px')};
      width: ${({ size }) => (size == 'small' ? '10px' : '18px')};
      height: ${({ size }) => (size == 'small' ? '10px' : '18px')};
    }
  }
`;
